import React from 'react'

const Outcome = () => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg">
    <path d="M2.973 0C1.33 0 0 1.279 0 2.857V20c0 .253.105.496.292.675.35 1.204 1.324 2.182 2.68 2.182h15.856a1 1 0 0 0 .87-.472.92.92 0 0 0 0-.96 1 1 0 0 0-.87-.473H2.973c-.56 0-.991-.414-.991-.952s.431-.952.99-.952h14.865c1.095 0 1.982-.853 1.982-1.905V1.905C19.82.852 18.932 0 17.837 0H2.973z" />
  </svg>
)

export default Outcome
